import { makeObservable, observable, action, reaction,computed } from 'mobx';
import axios, { storeGet } from "../utils/axios";
import historyVars from "../utils/historyVars";
import errors from "../reducers/errors";

import configStore from "./data_loaders/configStore";
import dataStore from "./data_loaders/dataStore";
import memoryStore from "./data_loaders/memoryStore";
import searchStore from "./data_loaders/searchStore";
import filter from "../utils/filter";
import { history } from "../history_mobx";

import Item from "../components/Blog/Item";
import ItemMedium from "../components/Blog/ItemMedium";
import ItemSmall from "../components/Blog/ItemSmall";

class photoStore {
  config={
    sorter:[],
    view_mode:"small",
    show_view_chooser:true,
    // title:this.par.stores.translateStore.photo.title,
    modes:{
      small:{ component:"PhotoItem", wrap_class:"up12 s-size-2 m-size-4 h-size-5 margin" },
      // medium:{ component:"BlogItemMedium", wrap_class:"up12 margin s-size-1 m-size-2 h-size-2", },
      // small:{ component:"BlogItemSmall", wrap_class:"up12 margin s-size-4 m-size-9 h-size-11", }
    }
  }
  constructor(par,config) {
    this.par=par;
    this.configStore=new configStore(this);
    this.memoryStore=new memoryStore(this);
    this.searchStore=new searchStore(this);
    this.dataStore=new dataStore(this);

    const t=par.stores.translateStore.t.photo;
    if(!config) {
      config={};
    }

    this.configStore.setConfig({
      layout:[],
      layout_marker: "photo_store",
      default_filter:"figure_name",
      disable_str_mask:true,
      default_order:{"id":"desc"},
      data_route:"/api/photo",
      pathname_only:history.location.pathname,
      system_filter:config.filter || null,
      fields:[
        filter.string({ name: t.FIGURE_NAME, code:'figure_name' }),
        filter.string({ name: t.CHARACTER, code:'figure_character_name' }),
        filter.string({ name: t.ORIGINAL, code:'figure_original' }),
        filter.figure_list({code: "figure_id", name: "Фигурка", }),
        filter.full_list({code: "figure_type_id", name: t.FIGURE_TYPE, }),
        filter.date({code: "created_time", name: t.UPLOADED, }),
      ]
    });

    /*
    { name: t.FIGURE_NAME, code:'cacher__text__figures', type:'text' },
    { name: t.CHARACTER, code:'cacher__text__characters', type:'text' },
    { name: t.ORIGINAL, code:'cacher__text__original', type:'text' },
    { name: t.FIGURE_TYPE, code:'figure_type_text', type:'ajax_select', get_url:'/api/figure/types' },
    { name: t.PUBLISH_TYPE, code:'public', type:'select', options:{'figures':'only figures','albums':'only public folders','figures_and_albums':'figures and folders'} },
    { name: t.UPLOADED, code:'upload_time', type:'select', options:optionsUploaded },
    */
    makeObservable(this, {
      config: observable,
      view_mode: computed,
    });

    this.prepareConfig();

  }
  get view_mode() {
    return this.config.modes[this.config.view_mode];
  }
  prepareConfig() {
    const ord = this.par.stores.translateStore.t.order;
    this.config.title=this.par.stores.translateStore.t.photo.SPOT_TITLE;

    this.config.sorter=[
      {name: ord.DATE_ADDED2, code: 'id', start: 'desc', default: true},
      {name: ord.RATING, code: 'rating_mark', start: 'desc', default: false},
      {name: ord.COMMENTS, code: 'c_comments_value', start: 'desc', default: false},
    ];
  }
  destroy() {
    const arr=[this.memoryStore];
    for(let i in arr) {
      arr[i].destroy();
    }
  }
  getStores() {
    return {
      configStore: this.configStore,
      dataStore: this.dataStore,
      memoryStore: this.memoryStore,
      searchStore: this.searchStore,
      dataCombiner: this,
    }
  }
  /*fetchMe() {
    storeGet(`/api/user/me`, this.me);
  }*/

}


export default photoStore;
